import { useTranslation } from "#hooks";
import { Translations } from "#interfaces";
import { bp } from "#shared/theme";
import React from "react";
import { useMediaQuery } from "react-responsive";
import { ChartContainer } from "../ChartContainer/ChartContainer";
import { InfoItemProps } from "../Info/Info";
import { ShareEarningsChartDesktop } from "../ShareEarningsChartDesktop/ShareEarningsChartDesktop";
import { ShareEarningsChartMobile } from "../ShareEarningsChartMobile/ShareEarningsChartMobile";

export const ShareEarningsChart: React.FC = () => {
  const { t } = useTranslation("tour");
  const labels = t("ShareEarningsChart") as Translations;
  const isDesktop = useMediaQuery({ query: bp.m });
  return (
    <ChartContainer
      title={labels.title}
      tooltipContent={labels.tooltip}
      list={(labels.info as unknown) as InfoItemProps[]}
    >
      {isDesktop ? <ShareEarningsChartDesktop labels={labels} /> : <ShareEarningsChartMobile labels={labels} />}
    </ChartContainer>
  );
};
